module.exports = __webpack_public_path__ + "img/curved-rail-horizontal-right-top-ties.f38bf8a1.png";